module.exports = __webpack_public_path__ + "static/img/px.7adb3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/px.png
// module id = GP+l
// module chunks = 1